'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'motorcycle';
var width = 640;
var height = 512;
var aliases = [127949];
var unicode = 'f21c';
var svgPathData = 'M382.7 41.8l16.8 39.9 23.9-15.2 3.9-2.5 84.7 0 0 96-79.5 0 28.9 68.7c11-3.1 22.6-4.7 34.5-4.7 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-47.4 25.7-88.7 64-110.8l-14.7-34.8C369.2 229.7 336 279 336 336l0 32-65 0c-7.9 63.1-61.7 112-127 112-70.7 0-128-57.3-128-128S73.3 224 144 224c65.3 0 119.1 48.9 127 112l32.3 0c-8-80.9-76.3-144-159.2-144l-80 0 0-32 80 0c34.1 0 66.1 8.9 93.9 24.5l9.5-6 124.7-79.4-14.7-35.1-69.4 0 0-32 90.6 0 4.1 9.8zM144 256c-53 0-96 43-96 96s43 96 96 96c47.6 0 87-34.6 94.7-80l-126.7 0 0-32 126.7 0c-7.6-45.4-47.1-80-94.7-80zm352 0c-7.6 0-14.9 .9-22 2.6l36.7 87.2 6.2 14.7-29.5 12.4-6.2-14.8-36.7-87.2c-26.7 17-44.5 46.9-44.5 81 0 53 43 96 96 96s96-43 96-96-43-96-96-96zM266.6 204.2c21.2 17.6 38.6 39.7 50.6 64.8 16.7-40.6 48.2-73.5 87.7-92.2L384.7 129 266.6 204.2zm145.6-92.6l6.9 16.4 60.9 0 0-32-43.3 0-24.5 15.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMotorcycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;